<div class="main-news">
  <div class="main-news__title">
    <h3>Новости</h3>
  </div>
  <div class="main-news__content">
    <div class="main-news__loading animated faster fadeIn" *ngIf="NewsLoading">
      <div class="ui-loader ui-loader__page-light"></div>
    </div>
    <div class="grid align-items-center justify-content-center main-news__slide"
      ngClass="{{(deviceValue | async) === DTypes.Desktop ? '' : 'flex-column'}}">

      <ng-container *ngFor="let News of NewsListData; let i = index">
        <div class="col-3 no-padding main-news__content-item" ngClass="{{i % 2 === 0 ? 'revert' : ''}}">
          <div class="grid h-full align-items-start flex-column">
            <div class="main-news__content-item_preview">
              <a routerLink="/{{Routing.News}}/{{News.id}}" target="_blank">
                <img src="{{StaticURL}}{{News.thumbnailPath}}" *ngIf="!NewsThumbnailError" (error)="NewsThumbnailError = true">

                <div class="grid h-full align-items-center justify-content-center" *ngIf="NewsThumbnailError">
                  <div class="col-10">
                    <div class="ui-logo__footer"></div>
                  </div>
                </div>
              </a>
            </div>
            <div class="main-news__content-item_info">
              <div class="main-news__content-item_date">
                <span class="mr-icon mr-icon-clock"></span>
                <span>{{News.created | formatDate}}</span>
              </div>
              <div class="main-news__content-item_heading" [ngStyle]="{'-webkit-box-orient': 'vertical'}">
                <a routerLink="/{{Routing.News}}/{{News.id}}" target="_blank">{{News.title}}</a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="main-news__button">
    <button class="ui-buttons ui-buttons__blue-large no-shadow" (click)="onViewAllNews()" pRipple>
      Все новости
    </button>
  </div>
</div>
